/* eslint-disable react/no-unescaped-entities */
import { Dropdown, Menu, Modal, Space } from 'antd'
import { BaseButton } from 'components/elements/BaseButton'
import { globalToaster } from 'components/elements/global'
import useAppControl from 'hooks/useAppControl'
import { FC, useState } from 'react'
import { TSendWidgetState } from 'types'
import useAuth from 'hooks/useAuth'
import { useProListing } from '../provider/ProListingProvider'
import { TPropertyListing } from '../types'

export const ProSendEmailSMSComponent: FC<{
 onChangeSelection?: () => void
 addListBtnType?: 'add' | 'remove'
 showSelectionBtn?: boolean
 from: 'modal' | 'list'
 proData?: TPropertyListing
 onHide?: () => void
}> = ({
 onChangeSelection,
 addListBtnType,
 showSelectionBtn,
 from,
 proData,
 onHide,
}) => {
 const { user } = useAuth()
 const { updateSendEmailWidget, updateSendSMSWidget } = useAppControl()
 const { selectedPro, lType } = useProListing()
 const [showInfoModal, setShowInfoModal] = useState(false)

 const onSubmit = (
  sendType: 'mail' | 'sms',
  mode: 'lead' | 'tag' | 'stage' | 'source',
 ): void => {
  if (
   from === 'list' &&
   sendType === 'sms' &&
   (selectedPro?.length ?? 0) > 10
  ) {
   globalToaster({
    type: 'error',
    content: 'You can select maximum 10 items at a time',
   })
  } else {
   const common: TSendWidgetState = {
    widgetFrom: 'listing',
    show: true,
    type: mode,
    propFullInfo: from === 'list' ? selectedPro : ([proData] as any),
    proListingType: lType,
   }

   if (sendType === 'mail') {
    updateSendEmailWidget(common)
   }
   if (sendType === 'sms') {
    updateSendSMSWidget(common)
   }

   if (from === 'modal') {
    onHide?.()
    const modals = document.getElementsByClassName(
     'pro-list-and-modal-close-btn',
    )

    Array.from(modals).forEach((modal) => (modal as HTMLElement)?.click())
   }
  }
 }

 return (
  <>
   <Space>
    <BaseButton
     type="primary"
     onClick={() => setShowInfoModal(true)}
     disabled={!selectedPro?.length && !proData}
    >
     <i className="fas fa-info-circle" />
    </BaseButton>
    {showSelectionBtn && (
     <BaseButton
      {...(addListBtnType === 'add'
       ? {
          buttonType: 'primary',
         }
       : {
          customClass: 'secondary-btn',
          buttonType: 'secondary',
         })}
      onClick={() => onChangeSelection?.()}
     >
      <i
       className={`fas ${
        addListBtnType === 'add' ? 'fa-plus' : 'fa-times'
       } me-2`}
      />
      {addListBtnType === 'add' ? 'Add to' : 'Remove from'} Selection
     </BaseButton>
    )}
    <Dropdown
     disabled={from === 'list' ? selectedPro?.length === 0 : false}
     placement="bottom"
     trigger={['click']}
     overlay={
      <Menu
       items={[
        {
         label: 'Email to Lead',
         onClick: () => onSubmit('mail', 'lead'),
         key: 'email-to-lead',
         icon: <i className="fas fa-envelope me-2" />,
        },
        {
         label: 'Email to Tag',
         onClick: () => onSubmit('mail', 'tag'),
         key: 'email-to-tag',
         icon: <i className="far fa-tags me-2" />,
        },
        {
         label: 'Email to Stage',
         onClick: () => onSubmit('mail', 'stage'),
         key: 'email-to-stage',
         icon: <i className="far fa-th me-2" />,
        },
        {
         label: 'Email to Source',
         onClick: () => onSubmit('mail', 'source'),
         key: 'email-to-source',
         icon: <i className="far fa-globe me-2" />,
        },
       ]}
      />
     }
    >
     <BaseButton type="primary" icon={<i className="fas fa-envelope me-2" />}>
      <Space>
       <span>Email to</span>
       <i className="fas fa-caret-down" />
      </Space>
     </BaseButton>
    </Dropdown>
    {user?.twilio_phone && (
     <Dropdown
      disabled={from === 'list' ? selectedPro?.length === 0 : false}
      placement="bottom"
      trigger={['click']}
      overlay={
       <Menu
        items={[
         {
          label: 'SMS to Lead',
          onClick: () => onSubmit('sms', 'lead'),
          key: 'sms-to-lead',
          icon: <i className="fas fa-envelope me-2" />,
         },
         {
          label: 'SMS to Tag',
          onClick: () => onSubmit('sms', 'tag'),
          key: 'sms-to-tag',
          icon: <i className="far fa-tags me-2" />,
         },
         {
          label: 'SMS to Stage',
          onClick: () => onSubmit('sms', 'stage'),
          key: 'sms-to-stage',
          icon: <i className="far fa-th me-2" />,
         },
         {
          label: 'SMS to Source',
          onClick: () => onSubmit('sms', 'source'),
          key: 'sms-to-source',
          icon: <i className="far fa-globe me-2" />,
         },
        ]}
       />
      }
     >
      <BaseButton type="primary" icon={<i className="fas fa-envelope me-2" />}>
       <Space>
        <span>SMS to</span>
        <i className="fas fa-caret-down" />
       </Space>
      </BaseButton>
     </Dropdown>
    )}
   </Space>
   {showInfoModal && (
    <Modal
     visible={showInfoModal}
     onCancel={() => setShowInfoModal(false)}
     cancelButtonProps={{
      hidden: true,
     }}
     onOk={() => setShowInfoModal(false)}
     okText="Close"
    >
     <div className="mt-3">
      {from === 'list' ? (
       <>
        <p>
         1. Sending an email or SMS from the current listing page will send all
         the selected listings in the "Selected Properties" list
        </p>
        <p>
         2. If listings are selected from any of the following:
         <span className="d-block">(a) the current listing page, </span>
         <span className="d-block">
          (b) the detail page of any property on the current page, or{' '}
         </span>
         <span className="d-block">
          (c) a property added from a search on the current page,{' '}
         </span>
         then the preloaded content of the email/SMS will match the content of
         the current listing page. (Note: Even if the searched property differs
         from the ones on the current page, the content will still reflect the
         current listing page.)
        </p>
        {/* <p>
         3. If a listing is selected after opening the similar listings page,
         the preloaded content for the email/SMS will match the type of listings
         added to the "Selected Properties" list. If all the listings are of the
         same type, the corresponding content will be loaded; otherwise, a
         generic content will be loaded.
        </p> */}
       </>
      ) : (
       <>
        <p>
         1. Sending an email or SMS from the listing's detail page will only
         send the current listing, not the other listings in the "Selected
         Properties" list.
        </p>
        <p>
         {' '}
         2. To send the current listing along with other selected listings, add
         the current listing to the list, then close the detail page and send
         the email/SMS from the listing page.
        </p>
       </>
      )}
     </div>
    </Modal>
   )}
  </>
 )
}

export default ProSendEmailSMSComponent
